import type { PdfRect } from "./pdfBearbeitung";
import type { ViewportLike } from "./pdfKoordinaten";

/**
 * Reine Rechnungen fürs Verschieben eines Ausschnitts (Review 28.09.2026,
 * Befund 7): das Ziel ergibt sich aus der AKTUELLEN Zeigerposition — nicht aus
 * „alte Box + Mausweg“, das beim Scrollen während des Ziehens danebenläge.
 */

const r2 = (n: number) => Math.round(n * 100) / 100;

export interface SeiteImFenster {
    seite: number;
    /** Inhaltsfläche der Seite im Fenster (ohne Rahmen). */
    box: DOMRect;
    viewport: Pick<ViewportLike, "convertToPdfPoint">;
}

/**
 * Wohin fällt der Ausschnitt? Mitte = Zeiger minus Greif-Versatz (Abstand
 * Zeiger ↔ Mitte beim Zugreifen). Zielseite ist die Seite unter der Mitte, die
 * Größe in pt bleibt (kein Verzerren auf anders gedrehten Seiten).
 */
export function zielDesAusschnitts(
    zeiger: { x: number; y: number },
    versatz: { x: number; y: number },
    seiten: readonly SeiteImFenster[],
    groesse: { w: number; h: number },
): { seite: number; rect: PdfRect } | null {
    const mx = zeiger.x - versatz.x;
    const my = zeiger.y - versatz.y;
    const s = seiten.find(({ box }) => mx >= box.left && mx <= box.right && my >= box.top && my <= box.bottom);
    if (!s) return null;
    const [cx, cy] = s.viewport.convertToPdfPoint(mx - s.box.left, my - s.box.top);
    const { w, h } = groesse;
    return { seite: s.seite, rect: [r2(cx - w / 2), r2(cy - h / 2), r2(cx + w / 2), r2(cy + h / 2)] };
}

/** Zone am oberen/unteren Rand des Containers, in der beim Ziehen gescrollt wird. */
export const AUTOSCROLL_ZONE = 40;
const MAX_SCHRITT = 20;

/** Scroll-Schritt je Takt (px, negativ = nach oben) für die Zeigerhöhe `y`. */
export function autoScrollSchritt(y: number, rand: { top: number; bottom: number }): number {
    if (rand.bottom - rand.top <= 0) return 0;
    const oben = rand.top + AUTOSCROLL_ZONE - y;
    if (oben > 0) return -Math.round(Math.min(1, oben / AUTOSCROLL_ZONE) * MAX_SCHRITT);
    const unten = y - (rand.bottom - AUTOSCROLL_ZONE);
    if (unten > 0) return Math.round(Math.min(1, unten / AUTOSCROLL_ZONE) * MAX_SCHRITT);
    return 0;
}
